import { render, staticRenderFns } from "./ShopXq.vue?vue&type=template&id=46fc126d&scoped=true&"
import script from "./ShopXq.vue?vue&type=script&lang=js&"
export * from "./ShopXq.vue?vue&type=script&lang=js&"
import style0 from "./ShopXq.vue?vue&type=style&index=0&id=46fc126d&lang=less&scoped=scoped&"
import style1 from "./ShopXq.vue?vue&type=style&index=1&id=46fc126d&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc126d",
  null
  
)

export default component.exports